export default __webpack_public_path__ + "static/media/payment-methods.c8794e58.png";